import { render, staticRenderFns } from "./LmsContentSelector.vue?vue&type=template&id=138f4bc1&scoped=true"
import script from "./LmsContentSelector.vue?vue&type=script&lang=js"
export * from "./LmsContentSelector.vue?vue&type=script&lang=js"
import style0 from "./LmsContentSelector.vue?vue&type=style&index=0&id=138f4bc1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "138f4bc1",
  null
  
)

export default component.exports